//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"AngularTolerance",1,0],[0,"Annotationboundingbox",1,0],[0,"Annotationtextboundingbox",1,0],[0,"Autovalidate",1,0],[0,"BodyValidation",1,0],[0,"CaeObjValidation",1,0],[0,"CentroidTolerance",1,0],[0,"CollectorValidation",1,0],[0,"CompareConvergentMinimumRadius",1,0],[0,"CurvePointValidation",1,0],[0,"DirKeyword",1,0],[0,"DisableExpressionValidation",1,0],[0,"DisableGeometryValidation",1,0],[0,"DisableShapeValidation",1,0],[0,"DistanceTolerance",1,0],[0,"DraftingValidation",1,0],[0,"FaceEdgeValidation",1,0],[0,"FeatureValidation",1,0],[0,"FunctionalArea",1,0],[0,"InfoValidation",1,0],[0,"JoinPublishValidation",1,0],[0,"Language",1,0],[0,"Library",1,0],[0,"MassPropPercentDifference",1,0],[0,"ModelingValidationOption",1,0],[0,"ObjectDetails",1,0],[0,"PartfileKeyword",1,0],[0,"RepositoryKeyword",1,0],[0,"SheetmetalValidationOption",1,0],[0,"ShipCurveTolerance",1,0],[0,"SignificantDifference",1,0],[0,"Subdirectory",1,0],[0,"SubobjectNesting",1,0],[0,"TreeListValidation",1,0],[0,"UseCustomerDefaultsFile",1,0],[0,"UseParasolidErrorBounds",1,0]],[],[]];
SPLM.AutotestPreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AutotestPreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AutotestPreferencesBuilder.LanguageType = Object.freeze({
    "VisualBasic" : "VisualBasic", "CPlusPlus" : "CPlusPlus", "Java" : "Java", "CSharp" : "CSharp", "Python" : "Python"});

SPLM.AutotestPreferencesBuilder.ValidationOption = Object.freeze({
    "None" : "None", "AtEnd" : "AtEnd", "AtEndAndAtUpdate" : "AtEndAndAtUpdate"});

SPLM.AutotestPreferencesBuilder.SubobjectNestingOption = Object.freeze({
    "None" : "None", "NestSubobjects" : "NestSubobjects"});

SPLM.AutotestPreferencesBuilder.ObjectDetailsOption = Object.freeze({
    "HideDetails" : "HideDetails", "ShowDetails" : "ShowDetails"});

SPLM.AutotestPreferencesBuilder.CollectorValidationOption = Object.freeze({
    "None" : "None", "All" : "All"});

SPLM.AutotestPreferencesBuilder.ModelingValidationOpt = Object.freeze({
    "None" : "None", "AtEnd" : "AtEnd"});

SPLM.AutotestPreferencesBuilder.ModelingObjectOption = Object.freeze({
    "All" : "All", "NewAndModified" : "NewAndModified", "PreExisting" : "PreExisting", "None" : "None"});

SPLM.AutotestPreferencesBuilder.InfoValidationOption = Object.freeze({
    "None" : "None", "All" : "All"});

SPLM.AutotestPreferencesBuilder.DraftingValidationOption = Object.freeze({
    "None" : "None", "All" : "All"});

SPLM.AutotestPreferencesBuilder.TreeListValidationOption = Object.freeze({
    "None" : "None", "PartNavigator" : "PartNavigator"});

SPLM.AutotestPreferencesBuilder.CaeObjValidationOption = Object.freeze({
    "Full" : "Full", "Light" : "Light"});

SPLM.AutotestPreferencesBuilder.SheetMetalValidationOpt = Object.freeze({
    "None" : "None", "AtEnd" : "AtEnd"});

export default SPLM;